<template>
  <div>
    <!-- 상단 제목 -->
    <div class="topbanner" :aria-label="`${board.b_name}입니다.`">
      <h2 aria-hidden="true">{{board.b_name}}</h2>
    </div>
    <!--// 상단 제목 -->
    <!-- 메인 컨텐츠 영역 -->
    <article class="notice_contents">
      <table class="table table_notice">
        <caption>{{board.b_name}} 게시판</caption>
        <thead>
        <tr v-if="board.b_reply_yn=='N'">
          <th class="col75" scope="col" role="table" aria-label="게시판의 제목 입니다.">제목</th>
          <th class="col25" scope="col" role="table" aria-label="게시판의 작성일자 입니다.">작성일자</th>
        </tr>
        <tr v-if="board.b_reply_yn=='Y'">
          <th class="col50" scope="col">제목</th>
          <th scope="col25" v-if="board.b_reply_yn=='Y'">답변여부</th>
          <th class="col25" scope="col">작성일자</th>
        </tr>
        </thead>
        <tbody v-if="total_count>0">
        <tr v-for="content in board_list" :key="content.no" @click="pageView(content.no)">
          <td class="td_tit"><a href="javascript:void(0)">{{content.title}}</a></td>
          <td v-if="board.b_reply_yn=='Y' && content.reply_flag!=1" class="td_state_ing">확인중</td>
          <td v-if="board.b_reply_yn=='Y' && content.reply_flag==1" class="td_state_comp">답변완료</td>
          <td :aria-label="formattedRegistDate(content.regist_date)">{{content.regist_date }}</td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td :colspan="board.b_reply_yn=='Y'?3:2">조회된 게시물이 없습니다.</td>
        </tr>
        </tbody>
        <tfoot></tfoot>
      </table>
      <div class="form-group block_left" v-if="board.b_reg_flag == 2">
        <button class="btn_common btn_short" @click="write">글쓰기</button>
      </div>
      <div class="form-group block_right">
        <button class="btn_common btn_short" v-if="page>1" @click="prevPage">이전</button>
        <button class="btn_common btn_short" v-if="page<total_page" @click="nextPage">다음</button>
      </div>
      <!-- 검색 -->
      <form class="search_wrap form-horizontal" onsubmit="return false;">
        <select class="search_select" v-model="search_field" aria-label="검색할 목록 입니다.">
          <option value="" aria-label="전체, 모든내용에서 검색">전체</option>
          <option value="title" aria-label="제목에서 검색">제목</option>
          <option value="contents" aria-label="내용에서 검색">내용</option>
        </select>
        <div class="form-group">
          <input aria-label="검색할 내용을 작성후, 검색버튼을 눌러, 내용을 검색합니다."  type="search" class="form-control" placeholder="검색어 입력" v-model="search_text" />
          <button class="btn_common" @click="loadBoardList">검색</button>
        </div>
      </form>
      <!--// 검색 -->
    </article>
    <!--// 메인 컨텐츠 영역 -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      c_no: this.$route.params.c_no,
      page: 1,
      total_count: 0,
      total_page: 0,
      search_field: "",
      search_text: "",
      board: {},
      board_list: []
    }
  },

  mounted() {
    if(this.c_no == this.$store.state.search.c_no) {
      this.page = this.$store.state.search.page;
      this.search_field = this.$store.state.search.search_field;
      this.search_text = this.$store.state.search.search_text;
    }

    this.$store.commit('setSearch', {});
    this.loadBoardList();
  },

  watch: {
    '$route'(to, from)  {
      this.c_no = to.params.c_no;
      this.page = 1;
      this.search_field = "";
      this.search_text = "";
      this.$store.commit('setSearch', {});
      this.loadBoardList();
    }
  },
  methods: {
    loadBoardList() {
      this.$http.get('/api/board.do', {
        params: {
          c_no: this.c_no,
          page: this.page,
          search_field: this.search_field,
          search_text: this.search_text
        }
      }).then((response) => {
        if (response.data.retval == this.CONSTANT.SUCCESS) {
          this.board = response.data.boardInfo;
          this.total_count = response.data.total_count;
          this.total_page = response.data.total_page;
          this.board_list = response.data.boardList;
        } else {
          if (response.data.retval == this.CONSTANT.LOGIN_ERROR) {
            this.$store.commit("setSession", null);
            this.$router.push({path: "/m/login", query: {return_url: "/m/board/" + this.c_no}});
          } else {
            alert("게시물 조회를 실패하였습니다. [error_code:" + response.data.retval + "]");
          }
        }
      });
    },
    prevPage() {
      if (this.page > 1) {
        this.page--;
        this.loadBoardList();
      }
    },
    nextPage() {
      if (this.page < this.total_page) {
        this.page++;
        this.loadBoardList();
      }
    },
    pageView(b_c_no) {
      this.$store.commit('setSearch', {
        c_no: this.c_no,
        page: this.page,
        search_field: this.search_field,
        search_text: this.search_text
      });
      this.$router.push('/m/board/view/' + this.c_no + "/" + b_c_no);
    },
    write() {
      this.$store.commit('setSearch', {
        c_no: this.c_no,
        page: this.page,
        search_field: this.search_field,
        search_text: this.search_text
      });
      this.$router.push('/m/board/write/' + this.c_no);
    },
    formattedRegistDate(regist_date) {
      if (!regist_date) {
        return '';
      }
      // "24.01.23" 형식의 날짜를 "24년 1월 23일" 형식으로 변환
      const [year, month, day] = regist_date.split('.');
      return `${year}년 ${parseInt(month)}월 ${parseInt(day)}일`;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/board/List.vue